import React, { useState } from 'react';
import HamburgerMenu from '../../global/menu';
import AdminInsightsPanel from './AdminInsightsPanel';
import PromptTemplateEditor from './PromptTemplateEditor';
import InsightsScheduleCard from './InsightsScheduleCard';
import { BRANDING } from '../../config';
import '../../global/styles.css';

const ClientLogo = require(`../../assets/images/${BRANDING.logoFilename}`);

function AIInsightsDashboard({ userInfo, isAdmin = false, onLogout, onNavigate }) {
  const [activeView, setActiveView] = useState('insights');

  if (!isAdmin) {
    return (
      <div className="container-center">
        <div className="card card-center">
          <h1 className="title">Access Denied</h1>
          <p className="subtitle">You do not have permission to access this area.</p>
          <button
            onClick={() => onNavigate('home')}
            className="btn btn-primary btn-full"
          >
            Return to Home
          </button>
        </div>
      </div>
    );
  }

  const views = [
    { id: 'insights', label: 'AI Insights' },
    { id: 'templates', label: 'Prompt Templates' },
    { id: 'schedule', label: 'Schedule' },
  ];

  return (
    <div className="container">
      <HamburgerMenu
        isAdmin={isAdmin}
        onLogout={onLogout}
        onNavigate={onNavigate}
      />

      <div className="content">
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <img
            src={ClientLogo}
            alt={BRANDING.companyFullName}
            className="logo-location"
            style={{ marginBottom: '16px' }}
          />
          <h1 className="title">AI Compliance Insights</h1>
          <p className="subtitle">
            AI-powered analysis of narcotic inventory compliance
          </p>
        </div>

        {/* View Switcher */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '0',
            marginBottom: '24px',
            maxWidth: '500px',
            margin: '0 auto 24px',
          }}
        >
          {views.map((view, i) => (
            <button
              key={view.id}
              onClick={() => setActiveView(view.id)}
              style={{
                flex: 1,
                padding: '10px 16px',
                background:
                  activeView === view.id ? BRANDING.primaryColor : '#e2e8f0',
                color: activeView === view.id ? '#fff' : '#555',
                border: 'none',
                cursor: 'pointer',
                fontSize: '13px',
                fontWeight: '600',
                borderRadius:
                  i === 0
                    ? '8px 0 0 8px'
                    : i === views.length - 1
                    ? '0 8px 8px 0'
                    : '0',
              }}
            >
              {view.label}
            </button>
          ))}
        </div>

        {/* Active View */}
        <div style={{ padding: '0 10px' }}>
          {activeView === 'insights' && (
            <AdminInsightsPanel userInfo={userInfo} />
          )}
          {activeView === 'templates' && (
            <PromptTemplateEditor userInfo={userInfo} />
          )}
          {activeView === 'schedule' && <InsightsScheduleCard />}
        </div>
      </div>

      <footer className="footer">
        <p className="text-small">
          AI Compliance Insights - NarcoticTrack &copy; 2025 NarcoticTrack Inventory System, LLC
        </p>
      </footer>
    </div>
  );
}

export default AIInsightsDashboard;
